import { Slide, ToastContainer as ToastifyContainer } from 'react-toastify';

export const ToastContainer = () => {
  return (
    <ToastifyContainer
      hideProgressBar
      closeButton={false}
      transition={Slide}
      className="right-0 top-16 md:top-19"
      draggable={false}
      toastStyle={{
        alignItems: 'stretch',
        width: 'auto',
        padding: 0,
      }}
      style={{
        zIndex: 40,
      }}
    />
  );
};
